import { useQuery } from '@tanstack/react-query';
import { AdvancedFilterPanel } from '@/components/common/AdvancedFilter';
import { departmentListQueryOptions } from '@/features/organization/api/organization.api';
import { useGeoCascade } from '@/hooks/useGeoCascade';
import { getFilterPanelProps, type UrlSyncedFilters } from '@/hooks/useUrlSyncedFilters';
import { getDepartmentFilterField, getGeoFilterFields } from '@/utils/filterFields';
import { FILTER_KEYS, parseNumberFilter } from '@/utils/filters';

interface SurveySubmissionFilterPanelProps {
  filters: UrlSyncedFilters;
}

export function SurveySubmissionFilterPanel({ filters }: SurveySubmissionFilterPanelProps) {
  const { filterValues } = filters;

  const { data: departments } = useQuery(departmentListQueryOptions());
  const geoOptions = useGeoCascade({
    divisionId: parseNumberFilter(filterValues[FILTER_KEYS.divisionId]),
    districtId: parseNumberFilter(filterValues[FILTER_KEYS.districtId]),
  });

  return (
    <AdvancedFilterPanel
      fields={[
        getDepartmentFilterField(departments),
        ...getGeoFilterFields(filterValues, geoOptions),
        { key: 'userName', label: 'User Name', type: 'text', placeholder: 'e.g., Kausar' },
        { key: 'userHrId', label: 'HR ID', type: 'text', placeholder: 'e.g., HR-001' },
        { key: 'contactNumber', label: 'Contact Number', type: 'text', placeholder: '01XXXXXXXXX' },
      ]}
      {...getFilterPanelProps(filters)}
    />
  );
}
